export const ROUND_FOUND_ORDER = 'timewreck/round/FOUND_ORDER';
export const ROUND_WRONG_ORDER = 'timewreck/round/WRONG_ORDER';
export const ROUND_CLOSE_WRONG_ORDER_MODAL = 'timewreck/round/CLOSE_WRONG_ORDER_MODAL';
export const ROUND_CLOSE_OUT_OF_ENERGY_MODAL = 'timewreck/round/CLOSE_OUT_OF_ENERGY_MODAL';
export const ROUND_OUT_OF_ENERGY = 'timewreck/round/OUT_OF_ENERGY';
export const ROUND_OUT_OF_LIVES = 'timewreck/round/OUT_OF_LIVES';
export const ROUND_OUT_OF_TIME = 'timewreck/round/OUT_OF_TIME';